// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogEntityContainer } from '@lyearn/molecules';
// components
// types
import { CertificateTemplateType } from '@/types/schema';

import CertificateCard from '../CertificateCard';

function DeleteCertificateDialog({
  certificateTemplate,
  onClose,
  onDelete,
}: {
  certificateTemplate?: CertificateTemplateType | null;
  onClose: () => void;
  onDelete: () => void;
}) {
  const { t } = useTranslation();

  if (!certificateTemplate) {
    return null;
  }

  return (
    <AlertDialog
      header={{
        title: t('Certificate:Form.RemoveCertificate'),
        description: t('Certificate:Form.RemoveCertificateDescription'),
      }}
      primaryAction={{
        label: t('Certificate:Form.YesRemove'),
        onClick: onDelete,
        appearance: 'danger',
      }}
      onClose={onClose}>
      <DialogEntityContainer>
        <CertificateCard certificate={certificateTemplate!} className="" />
      </DialogEntityContainer>
    </AlertDialog>
  );
}

export default React.memo(DeleteCertificateDialog);
